import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import Login from './pages/login/Login';
import Home from './pages/home/Home';
import { renderToStaticMarkup } from "react-dom/server";
import { withLocalize } from "react-localize-redux";
var globalTranslations = require("./translations/global.json");

declare global {
  interface Window { google: any, account: any }
}
window.google = window.google || {};
window.account = window.account || {};

class AppRoot extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.props.initialize({
      languages: [
        { name: "English", code: "en" },
        { name: "עברית", code: "he" }
      ],
      translation: globalTranslations,
      options: { renderToStaticMarkup, defaultLanguage: "he" }
    });
  }


  public render() {
    let lang = this.props.activeLanguage? this.props.activeLanguage.code : "he"
    return (
      <div id="app-root" lang={lang}>
      <Switch>
        <Route path={`/login/:type`} component={Login} />
        <Route path={`/`} component={Home} />
      </Switch>
      </div>
    );
  }
}

export default withLocalize(AppRoot);



// WEBPACK FOOTER //
// ./src/root.tsx